import rawList from '@/enums/articleNumberMapping';

export interface ArticleMappingEntry {
  name: string;
  productKey: string;
  customizedNumber: string;
  value?: string;
}

export type ArticleMappingGroups = Record<string, ArticleMappingEntry[]>;

export class ArticleNumberResolver {
  private lookup: Record<string, { type: string; entry: ArticleMappingEntry }> =
    {};

  constructor(private groups: ArticleMappingGroups) {
    this.buildLookup();
  }

  private buildLookup() {
    for (const type of Object.keys(this.groups)) {
      const list = this.groups[type];

      for (const entry of list) {
        const key = entry.productKey;

        if (!this.lookup[key]) {
          this.lookup[key] = { type, entry };
        }
      }
    }
  }

  resolveCustomizedNumber(productKey: string) {
    return this.lookup[productKey]?.entry.customizedNumber ?? productKey;
  }

  getMapping(productKey: string): ArticleMappingEntry | undefined {
    return this.lookup[productKey]?.entry;
  }
}

const articleNumberMapper = new ArticleNumberResolver(rawList);
export default articleNumberMapper;
